import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { HashType } from '@whitbread-eos/api';
import * as crypto from 'crypto';
export function hashString(_x, _x2) {
  return _hashString.apply(this, arguments);
}
function _hashString() {
  _hashString = _asyncToGenerator(function* (input, hashType) {
    try {
      var _window$crypto;
      if (typeof window !== 'undefined' && (_window$crypto = window.crypto) !== null && _window$crypto !== void 0 && _window$crypto.subtle) {
        var encoder = new TextEncoder();
        var data = encoder.encode(input);
        var hashBuffer = yield window.crypto.subtle.digest(hashType, data);
        var hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
      } else {
        var nodeHash = crypto.createHash(convertHashTypeToNodeAlgorithm(hashType));
        nodeHash.update(input);
        return nodeHash.digest('hex');
      }
    } catch (error) {
      if (error instanceof Error) {
        console.error("Failed to hash the provided string: ".concat(error.message));
      } else {
        console.error("Failed to hash the provided string due to an 'Unknown Error'");
      }
    }
    return undefined;
  });
  return _hashString.apply(this, arguments);
}
function convertHashTypeToNodeAlgorithm(hashType) {
  switch (hashType) {
    case HashType.SHA256:
      return 'sha256';
    case HashType.SHA384:
      return 'sha384';
    case HashType.SHA512:
      return 'sha512';
    default:
      throw new Error("Unsupported hash type: ".concat(hashType));
  }
}